import { render } from "./ProblemStatisticsPage.vue?vue&type=template&id=fb83b278&scoped=true&ts=true"
import script from "./ProblemStatisticsPage.vue?vue&type=script&lang=ts"
export * from "./ProblemStatisticsPage.vue?vue&type=script&lang=ts"

import "./ProblemStatisticsPage.vue?vue&type=style&index=0&id=fb83b278&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb83b278"]])

export default __exports__